import React, { useState, useEffect, ChangeEvent } from 'react';
import { toAbsoluteUrl } from '../../_metronic/_helpers';
import { getMediaFullUrl } from '../helper/getMediaFullUrl';
import { sendImg } from '../modules/Quizzes/api/websocket';
import { getUploadUrl } from '../modules/Quizzes/api';

export function UseImageUpload({ imageObj, afterImageUpload }: { imageObj: { backgroundImage: string; image: string; }; afterImageUpload?: (arg0: string | ArrayBuffer) => void; }) {
    const [contentRef, setContentRef] = useState<any>(null);
    const [image, setBackgroundImage] = useState<HTMLInputElement | null>(null)
    useEffect(() => {
        if (imageObj.backgroundImage && contentRef) {
            contentRef.src = getMediaFullUrl(imageObj.backgroundImage);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contentRef])
    useEffect(() => {
        const updateImage = async () => {
            if (image && image.type) {
                const url = await getUploadUrl({ image })
                const imageUrl = await sendImg({ url: url?.data?.url, file: image })
                if (imageUrl && imageUrl.length) {
                    afterImageUpload && afterImageUpload(imageUrl)
                }
            }
        }
        updateImage()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image])
    function previewImage(params: ChangeEvent<HTMLInputElement>) {
        const preview = contentRef
        const file = params.target.files ? params.target.files[0] : null;
        if (!file || !file.type) {
            return;
        }
        const type = file.type;
        const reader = new FileReader();

        const the = {} as any
        reader.onloadend = function (e) {
            the.type = type;
            if (!e.target) {
                return;
            }
            the.blob = e.target.result;
            afterImageUpload && afterImageUpload(e.target.result || '')
            setBackgroundImage(the)
            preview.src = e.target.result;
        }
        
        if (file) {
            reader.readAsDataURL(file);
        }
    }
    return <div className="image-input image-input-outline" style={{ borderRadius: '6px' }}>
        <img src={getMediaFullUrl(imageObj.image)} alt=""
            style={{ width: '170px', objectFit: 'cover', borderRadius: '6px' }}
            ref={setContentRef} />
        <label className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="change" data-toggle="tooltip" title="" data-original-title="Change avatar">
            <img alt=""
                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
                style={{ width: '60%' }} />
            <input onChange={previewImage} type="file" name="profile_avatar" accept=".png, .jpg, .jpeg" />
            <input type="hidden" name="profile_avatar_remove" />
        </label>

        <span className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow" data-action="cancel" data-toggle="tooltip" title="Cancel avatar">
            <i className="ki ki-bold-close icon-xs text-muted"></i>
        </span>
    </div>;
}
